import { CalendarIcon, MagnifyingGlassIcon, PersonIcon } from "@radix-ui/react-icons";
import styles from "./style.module.css";
import { FakeWidjetInput } from "../../UI/WidjetInput/FakeWidjetInput";

// Поле "Гости"
function TextFieldRooms({ onMouseDown }) {
    return (
        <FakeWidjetInput
            icon={<PersonIcon />}
            label="Гости"
            onMouseDown={onMouseDown}
        />
    )
}

// Поле "Дата Выезда"
function TextFieldTo({ onMouseDown }) {
    return (
        <FakeWidjetInput
            icon={<CalendarIcon />}
            label="Выезд"
        />
    );
}

// Поле "Дата Заезда"
function TextFieldFrom({ onMouseDown }) {
    return (
        <FakeWidjetInput
            icon={<CalendarIcon />}
            label="Заезд"
        />
    );
}


export function FakeWidjet({ children, showLongLoadingNotification = false }) {
    return (
        <div className={styles.wrapper}>
            <form className={styles.form} onSubmit={e => e.preventDefault()}>
                <TextFieldFrom />
                <TextFieldTo />
                <TextFieldRooms />
                <button color="dark" className={styles.submit}><MagnifyingGlassIcon /> Загрузка...  </button>
            </form>
            {showLongLoadingNotification && (
                <div className={styles.longLoadingNotification}>
                    Мы пытаемся подключиться, подождите или зайдите позже
                </div>
            )}
        </div>
    );
}